export default __webpack_public_path__ + "static/media/txt2_sp.f1faa00e.png";